export const SECONDARY_SUBJECT_MAP = {
  9: [17, 23, 26, 29, 31, 32, 33, 34, 35, 36, 37, 70, 71],
  10: [17, 23, 29, 31, 32, 33, 35, 38, 39, 40, 41, 42],
};

export const filterSecondarySubjects = (subjects, standardIndex, selectedSem) => {
  const allowedIds = SECONDARY_SUBJECT_MAP[Number(standardIndex)];
  if (!allowedIds) return [];

  return (subjects || []).filter((item) =>
    allowedIds.includes(Number(item?.id))
  );
};
